<script setup lang="ts">
import { computed } from "vue"
import { usePage } from "@inertiajs/vue3"
import { GalleryVerticalEndIcon } from "@lucide/vue"
import { Link } from "@inertiajs/vue3"
import LocaleSwitcher from "@/components/LocaleSwitcher.vue"
import { normalizeLocale } from "@/i18n"
import type { SharedProps } from "@/types"

const page = usePage<SharedProps>()
const locale = computed(() => normalizeLocale(page.props.locale))
const year = new Date().getFullYear()
</script>

<template>
  <div class="min-h-screen bg-background text-foreground">
    <nav class="flex items-center justify-end px-6 py-4">
      <LocaleSwitcher />
    </nav>
    <main class="mx-auto flex max-w-sm flex-col gap-6 p-6">
      <Link href="/" class="flex items-center gap-2 self-center">
        <span
          class="flex size-6 items-center justify-center rounded-md bg-primary text-primary-foreground"
        >
          <GalleryVerticalEndIcon class="size-4" />
        </span>
        <span class="font-bold">Reflekt</span>
      </Link>
      <slot />

      <div class="flex justify-between px-6 text-center text-xs text-gray-500">
        <div>&copy; {{ year }} Reflekt&reg;</div>
        <div>
          <a
            :href="`https://reflekt.ai/${locale}`"
            target="_blank"
            rel="noopener noreferrer"
            class="link font-normal"
          >
            Reflekt Software GmbH
          </a>
        </div>
      </div>
    </main>
  </div>
</template>
